"use client"

import { Button } from "@ui/shad"
import { HelpCircle } from "lucide-react"

import { DOCS_URL } from "@/lib/docs"

export function DocsLauncher() {
  return (
    <Button variant="ghost" size="iconSm" asChild>
      <a href={DOCS_URL} target="_blank" rel="noreferrer">
        <HelpCircle />
        <span className="sr-only">Open docs</span>
      </a>
    </Button>
  )
}
